import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import LinkedAccountErrorViewButton from './LinkedAccountErrorViewButton';

const LinkedAccountErrorViewPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.linkedAccountErrorView.name]: () => {
      return (
        <LinkedAccountErrorViewButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default LinkedAccountErrorViewPicker;
